// ===================================
// UTILS - Clasificador de errores de red/API
// ===================================
// Extraído de pages/tienda/utils.ts para reutilizarlo en cualquier página pública
// (tienda, consulta de boleta) que necesite traducir un error a un mensaje en español
// y una categoría para decidir cómo mostrarlo.
//
// El interceptor de respuesta de axios-client.ts SIEMPRE normaliza los errores HTTP a
// un ApiError plano { message, statusCode, fieldErrors?, timestamp } antes de que lleguen
// acá (ver packages/core/src/infrastructure/http/axios-client.ts) — nunca llega el
// AxiosError crudo con `.response.status`. Por eso se lee `err.statusCode`, no
// `err.response.status`.

export type TipoError = 'red' | 'servidor' | 'validacion' | 'desconocido';

interface ApiErrorLike {
  message?: string;
  statusCode?: number;
}

export function clasificarError(err: unknown): { mensaje: string; tipo: TipoError } {
  const apiError = err as ApiErrorLike;
  const status = apiError?.statusCode;

  // statusCode 0 = error de red/conexión, seteado por el interceptor cuando no hay response
  if (status === 0)
    return { mensaje: apiError.message || 'Sin conexión. Revisa tu internet e intenta nuevamente.', tipo: 'red' };
  if (status && status >= 500)
    return { mensaje: 'Error en el servidor. Intenta en unos minutos.', tipo: 'servidor' };
  if (status === 429)
    return {
      mensaje: apiError.message ?? 'Demasiadas solicitudes. Intenta nuevamente en unos minutos.',
      tipo: 'validacion',
    };
  if (status === 404)
    return { mensaje: apiError.message ?? 'No se encontró lo que buscabas.', tipo: 'validacion' };
  if (status === 409)
    return { mensaje: apiError.message ?? 'No fue posible completar la operación.', tipo: 'validacion' };
  if (status === 400 || status === 422)
    return {
      mensaje: apiError.message ?? 'Los datos ingresados no son válidos. Revisa el formulario.',
      tipo: 'validacion',
    };
  return { mensaje: apiError?.message || 'No se pudo completar la solicitud. Intenta nuevamente.', tipo: 'desconocido' };
}
